export default class GeneralOptions {
    public sessionLimit: number;
    public sessionLimitStep: number;
    public sessionLimitMin: number;
    public sessionLimitMax: number;

    public quickSpin: boolean;
    public displayCoins: boolean;
    public showIntro: boolean;
    public leftHanded: boolean;
    public spaceToSpin: boolean;
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/components/betbar/vo/general-options.ts